import { render, staticRenderFns } from "./friend-index.vue?vue&type=template&id=a9d6babc&scoped=true"
import script from "./friend-index.vue?vue&type=script&lang=js"
export * from "./friend-index.vue?vue&type=script&lang=js"
import style0 from "./friend-index.vue?vue&type=style&index=0&id=a9d6babc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d6babc",
  null
  
)

export default component.exports